module.exports = __webpack_public_path__ + "static/media/close.7662489d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/close.jpg
// module id = 2348
// module chunks = 0